import SearchIcon from "@mui/icons-material/Search";
import { IconButton, TextField } from "@mui/material";
import {
  emptyPlaceResult,
  placeResultFromPlace,
  searchPlaceFromQuery
} from "common/functions/placesUtilities";
import { PlaceResult } from "common/interfaces/PlaceResult";
import {
  ChangeEvent,
  KeyboardEvent,
  memo,
  useCallback,
  useEffect,
  useState
} from "react";
import styles from "../SearchMenu.module.scss";

export const PlaceInput = memo(
  (props: {
    map: google.maps.Map | null | undefined;
    placeholder?: string;
    disabled?: boolean;
    open?: boolean;
    onPlaceResultChange: (placeResult: PlaceResult) => void;
  }) => {
    const id = "place-text-field";

    const [value, setValue] = useState("");
    const [composing, setComposing] = useState(false);

    const onChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
      setValue(event.target.value);
    }, []);

    const onClick = useCallback(async () => {
      const place = await searchPlaceFromQuery(value, props.map);
      const placeResult = place
        ? placeResultFromPlace(place)
        : emptyPlaceResult();

      props.onPlaceResultChange(placeResult ?? emptyPlaceResult());
    }, [props, value]);

    const onCompositionStart = useCallback(() => {
      setComposing(true);
    }, []);

    const onCompositionEnd = useCallback(() => {
      setComposing(false);
    }, []);

    const onKeyDown = useCallback(
      (event: KeyboardEvent<HTMLInputElement>) => {
        if (composing) {
          return;
        }

        if (event.key === "Enter") {
          onClick();
        }
      },
      [composing, onClick]
    );

    useEffect(() => {
      props.onPlaceResultChange(emptyPlaceResult());
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.open]);

    return props.open ? (
      <TextField
        id={id}
        type="text"
        variant="standard"
        placeholder={props.placeholder}
        fullWidth
        onChange={onChange}
        onCompositionStart={onCompositionStart}
        onCompositionEnd={onCompositionEnd}
        onKeyDown={onKeyDown}
        slotProps={{
          input: {
            disableUnderline: true,
            endAdornment: (
              <IconButton className={styles.goButton} onClick={onClick}>
                <SearchIcon />
              </IconButton>
            )
          }
        }}
        disabled={props.disabled}
      />
    ) : null;
  }
);
